import { useQuery } from "@apollo/client";
import {
  GET_ROOT_ID,
  GetRootIdResponse,
} from "../../api/graphql/workplaces";
import { useAuthContext } from "../context/Auth/AuthContext";

export const useRootIdQuery = () => {
  const { user } = useAuthContext();
  const { data } = useQuery<GetRootIdResponse, { tenantId: string }>(
    GET_ROOT_ID,
    {
      variables: {
        tenantId: user?.customerid || "",
      },
      skip: !user?.customerid,
      fetchPolicy: "cache-first",
    }
  );

  const rootId = data?.queryTenant?.[0]?.id || "";

  return { rootId };
};
